import { authenticatedApi } from '../api';

export const API_CHANNEL_OPERATORS_PATH = '/channel/operators';

export const fetchOperatorsByChannelId = (channelId) => authenticatedApi
	.get(`${API_CHANNEL_OPERATORS_PATH}/byChannelId/${channelId}`);

export const fetchMyHosts = () => authenticatedApi.get(`${API_CHANNEL_OPERATORS_PATH}/my/hosts`);

export const fetchOperatorCandidates = () => authenticatedApi.get(`${API_CHANNEL_OPERATORS_PATH}/candidates`);

export const addOperators = ({ channelIds, validUntil }) => authenticatedApi.post(
	`${API_CHANNEL_OPERATORS_PATH}/add`,
	{ channelIds, validUntil },
);

export const removeOperator = (channelId) => authenticatedApi.delete(
	`${API_CHANNEL_OPERATORS_PATH}/${channelId}`,
);
